"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _taggedTemplateLiteralLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteralLoose"));

var _react = _interopRequireDefault(require("react"));

var _reactRedux = require("react-redux");

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _colors = require("HubStyleTokens/colors");

var _FormattedMessage = _interopRequireDefault(require("I18n/components/FormattedMessage"));

var _FormattedHTMLMessage = _interopRequireDefault(require("I18n/components/FormattedHTMLMessage"));

var _UIBox = _interopRequireDefault(require("UIComponents/layout/UIBox"));

var _UIFlex = _interopRequireDefault(require("UIComponents/layout/UIFlex"));

var _PriceDisplay = _interopRequireDefault(require("../common/pricing/PriceDisplay"));

var _ProductList = _interopRequireDefault(require("./ProductList"));

var _Terms = require("self-service-api/constants/Terms");

var _SuiteTileCTAsContainer = _interopRequireDefault(require("pricing-pages-unified-ui/components/growth-suite-page/SuiteTileCTAsContainer"));

var _SuiteViewAllFeatures = _interopRequireDefault(require("pricing-pages-unified-ui/components/growth-suite-page/SuiteViewAllFeatures"));

var _SuiteEditionIdentifiersMap = _interopRequireDefault(require("pricing-pages-unified-ui/constants/SuiteEditionIdentifiersMap"));

var _SuiteEditionMerchIdMap = _interopRequireDefault(require("pricing-pages-unified-ui/constants/SuiteEditionMerchIdMap"));

var _CurrencySelectors = require("pricing-pages-unified-ui/selectors/CurrencySelectors");

var _SpinnerLoadWrapper = _interopRequireDefault(require("../../components/loading/SpinnerLoadWrapper"));

var _responsiveBreakpoints = _interopRequireDefault(require("../../utils/responsiveBreakpoints"));

var _PromotionSelectors = require("pricing-pages-unified-ui/selectors/PromotionSelectors");

var _LoadingStateSelectors = require("pricing-pages-unified-ui/selectors/LoadingStateSelectors");

var _Hubs = require("self-service-api/constants/Hubs");

var _PromotionSelectors2 = require("../../selectors/PromotionSelectors");

var _SuiteCovidPromoBanner = _interopRequireDefault(require("./SuiteCovidPromoBanner"));

var _Editions = require("self-service-api/constants/Editions");

var _PricingSelectors = require("../../selectors/PricingSelectors");

var _itemConfigUtils = require("../../utils/itemConfigUtils");

var _MarketingContactsSelectors = require("../../selectors/MarketingContactsSelectors");

var _Tracking = require("../../constants/Tracking");

function _templateObject6() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n    flex-direction: column;\n  "]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n    padding-left: 20px;\n    padding-right: 20px;\n  "]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n    margin-top: 20px;\n    width: 100%;\n    margin-left: 0;\n  "]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n    padding: 20px;\n  "]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n    padding: 25px 20px;\n    > div {\n      flex-direction: column;\n    }\n  "]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n    height: auto;\n  "]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var Tile = _styledComponents.default.div.withConfig({
  displayName: "GrowthSuiteTile__Tile",
  componentId: "sc-1aik77g-0"
})(["width:100%;max-width:1100px;border-radius:0;border:1px solid ", ";height:337px;background:", ";&:not(:last-child){margin-bottom:32px;}", ";", ";"], _colors.BATTLESHIP, _colors.OLAF, _responsiveBreakpoints.default.tabletPortrait(_templateObject()), _responsiveBreakpoints.default.phone(_templateObject2()));

var TileContentContainer = _styledComponents.default.div.withConfig({
  displayName: "GrowthSuiteTile__TileContentContainer",
  componentId: "sc-1aik77g-1"
})(["padding:", ";", ""], function (props) {
  return props.hasBanner ? '24px 60px 60px' : '60px';
}, _responsiveBreakpoints.default.phone(_templateObject3()));

var Title = _styledComponents.default.div.withConfig({
  displayName: "GrowthSuiteTile__Title",
  componentId: "sc-1aik77g-2"
})(["font-size:26px;margin-bottom:10px;"]);

var SubTitle = _styledComponents.default.div.withConfig({
  displayName: "GrowthSuiteTile__SubTitle",
  componentId: "sc-1aik77g-3"
})(["font-size:16px;font-weight:normal;"]);

var Price = _styledComponents.default.div.withConfig({
  displayName: "GrowthSuiteTile__Price",
  componentId: "sc-1aik77g-4"
})(["font-size:36px;color:", ";margin-right:15px;"], _colors.OZ);

var PriceHeader = _styledComponents.default.div.withConfig({
  displayName: "GrowthSuiteTile__PriceHeader",
  componentId: "sc-1aik77g-5"
})(["font-size:12px;color:", ";margin-bottom:5px;"], _colors.EERIE);

var PerMonth = _styledComponents.default.span.withConfig({
  displayName: "GrowthSuiteTile__PerMonth",
  componentId: "sc-1aik77g-6"
})(["font-size:18px;"]);

var CrossedOutPrice = (0, _styledComponents.default)(_PriceDisplay.default).withConfig({
  displayName: "GrowthSuiteTile__CrossedOutPrice",
  componentId: "sc-1aik77g-7"
})(["color:", ";font-size:16px;line-height:27px;text-decoration:line-through;"], _colors.PANTERA);

var StyledCTAsContainer = _styledComponents.default.div.withConfig({
  displayName: "GrowthSuiteTile__StyledCTAsContainer",
  componentId: "sc-1aik77g-8"
})(["margin-left:10px;width:200px;text-align:center;button,a{width:100%;line-height:23px;}", ";"], _responsiveBreakpoints.default.phoneLarge(_templateObject4()));

var StyledSuiteCovidBanner = (0, _styledComponents.default)(_SuiteCovidPromoBanner.default).withConfig({
  displayName: "GrowthSuiteTile__StyledSuiteCovidBanner",
  componentId: "sc-1aik77g-9"
})(["", ""], _responsiveBreakpoints.default.phone(_templateObject5()));

var CardFlex = _styledComponents.default.div.withConfig({
  displayName: "GrowthSuiteTile__CardFlex",
  componentId: "sc-1aik77g-10"
})(["display:flex;flex-direction:row;", ""], _responsiveBreakpoints.default.phoneLarge(_templateObject6()));

var GrowthSuiteTile = function GrowthSuiteTile(_ref) {
  var edition = _ref.edition,
      currencyCode = _ref.currencyCode,
      growthSuiteDiscount = _ref.growthSuiteDiscount,
      hasPricingAndPurchasingSucceeded = _ref.hasPricingAndPurchasingSucceeded,
      isCovidGrowthSuitePromoEligible = _ref.isCovidGrowthSuitePromoEligible,
      getGrowthSuiteAvailableTerms = _ref.getGrowthSuiteAvailableTerms,
      calculateBundlePrice = _ref.calculateBundlePrice;
  var isInMCBeta = (0, _reactRedux.useSelector)(_MarketingContactsSelectors.isInMCBetaSelector);
  var shouldApplyCovidPromo = edition === _Editions.STARTER && isCovidGrowthSuitePromoEligible;
  var availableTerms = getGrowthSuiteAvailableTerms(shouldApplyCovidPromo);
  var defaultTerm = (0, _itemConfigUtils.getApplicableTerm)(_Terms.MONTHLY, availableTerms[edition]);
  var pricingInfo;
  var originalDiscountedPrice;

  if (hasPricingAndPurchasingSucceeded) {
    var params = {
      bundleSelections: {
        marketingPlanSelected: (0, _SuiteEditionMerchIdMap.default)(isInMCBeta)[edition][_Hubs.HUB_MARKETING],
        salesPlanSelected: (0, _SuiteEditionMerchIdMap.default)(isInMCBeta)[edition][_Hubs.HUB_SALES],
        servicePlanSelected: (0, _SuiteEditionMerchIdMap.default)(isInMCBeta)[edition][_Hubs.HUB_SERVICE]
      },
      term: defaultTerm,
      isGrowthSuite: true
    };
    pricingInfo = calculateBundlePrice(Object.assign({}, params, {
      isCovidPromo: shouldApplyCovidPromo
    })); // To get the _original_ discounted price to compare with Covid Promo price

    originalDiscountedPrice = calculateBundlePrice(params).monthly.calculatedPrice;
  }

  return _react.default.createElement(Tile, {
    "data-selenium-id": (0, _SuiteEditionIdentifiersMap.default)(isInMCBeta)[edition] + "-merch-card"
  }, _react.default.createElement(_SpinnerLoadWrapper.default, {
    isLoading: !hasPricingAndPurchasingSucceeded
  }, shouldApplyCovidPromo && _react.default.createElement(StyledSuiteCovidBanner, {
    toPrice: pricingInfo && pricingInfo.monthly.calculatedPrice,
    fromPrice: originalDiscountedPrice,
    currencyCode: currencyCode
  }), _react.default.createElement(TileContentContainer, {
    hasBanner: shouldApplyCovidPromo
  }, _react.default.createElement(CardFlex, null, _react.default.createElement(_UIBox.default, {
    grow: 1
  }, _react.default.createElement(Title, null, _react.default.createElement(_FormattedHTMLMessage.default, {
    message: "pricingPage.pages.growthSuite.title." + edition + "_html"
  })), // Don't render description if the promo banner exists, as there is a disagreement in discount math between the banner copy and subtitle copy
  !shouldApplyCovidPromo && _react.default.createElement(SubTitle, null, _react.default.createElement(_FormattedMessage.default, {
    message: "pricingPage.pages.growthSuite.discount." + edition,
    options: {
      percent: growthSuiteDiscount
    }
  })), _react.default.createElement(PriceHeader, {
    className: "m-top-6"
  }, _react.default.createElement(_FormattedMessage.default, {
    message: "pricingPage.pages.growthSuite.startsAt"
  })), _react.default.createElement(_UIFlex.default, {
    className: "m-bottom-6",
    align: "baseline"
  }, _react.default.createElement(Price, {
    "data-selenium-id": (0, _SuiteEditionIdentifiersMap.default)(isInMCBeta)[edition] + "-highlighted-price-per-month"
  }, _react.default.createElement(_PriceDisplay.default, {
    price: pricingInfo && pricingInfo.monthly.calculatedPrice,
    currencyCode: currencyCode
  }), _react.default.createElement(PerMonth, null, _react.default.createElement(_FormattedMessage.default, {
    message: "pricingPage.calculator.priceDisplay.perMonth"
  }))), _react.default.createElement(CrossedOutPrice, {
    price: shouldApplyCovidPromo ? originalDiscountedPrice : pricingInfo && pricingInfo.monthly.fullPrice,
    currencyCode: currencyCode
  })), _react.default.createElement("div", {
    style: {
      fontWeight: 600
    }
  }, _react.default.createElement("div", null, _react.default.createElement(_FormattedMessage.default, {
    message: "pricingPage.pages.growthSuite.includes"
  })), _react.default.createElement(_ProductList.default, {
    edition: edition
  }))), _react.default.createElement(StyledCTAsContainer, null, _react.default.createElement(_SuiteTileCTAsContainer.default, {
    edition: edition,
    isCovidPromo: isCovidGrowthSuitePromoEligible,
    trackingSource: _Tracking.SUITE_CARD
  }), _react.default.createElement("div", {
    className: "m-top-4"
  }, _react.default.createElement(_SuiteViewAllFeatures.default, {
    className: "m-top-4",
    edition: edition,
    currencyCode: currencyCode
  })))))));
};

var mapStateToProps = function mapStateToProps(state) {
  return {
    currencyCode: (0, _CurrencySelectors.activeCurrencySelector)(state),
    getGrowthSuiteAvailableTerms: function getGrowthSuiteAvailableTerms(isCovidPromo) {
      return (0, _PromotionSelectors2.growthSuiteAvailableTermsSelector)(state, isCovidPromo);
    },
    growthSuiteDiscount: (0, _PromotionSelectors.growthSuiteDiscountSelector)(state),
    hasPricingAndPurchasingSucceeded: (0, _LoadingStateSelectors.hasPricingAndPurchasingSucceededSelector)(state),
    calculateBundlePrice: (0, _PricingSelectors.getCalculateBundlePriceSelector)(state)
  };
};

var _default = (0, _reactRedux.connect)(mapStateToProps)(GrowthSuiteTile);

exports.default = _default;
module.exports = exports.default;